import { BLUE_GREY_200, GREEN_500 } from '@airtel/air-design-system';
export var simPortDetailsConfig = {
  state: 'none',
  isExpanded: false,
  autoFormSubmitDebounceDelay: 800,
  isAutoFormSubmitDebounceAllowed: false,
  stepDetailsProps: {
    title: 'STEP 3',
    heading: 'Add porting details',
    avatarIcon: 'PortSimIcon',
    avatarProps: {
      style: {
        backgroundColor: BLUE_GREY_200
      }
    },
    actionType: 'button',
    actionTypeProps: {
      buttonText: 'Change'
    },
    actionTypePosition: 'center'
  },
  inputsDataProps: {
    mobileNumber: {
      label: 'Mobile number to be ported',
      inputRegex: '^[6-9]{1}[0-9]*$',
      keyboardType: 'phone-pad',
      useStateHintColor: true,
      placeholder: 'Enter 10-digit mobile number',
      validationRegex: '^\\d{10}$',
      maxLength: 10
    },
    upcCode: {
      label: 'UPC code',
      placeholder: 'Enter UPC code',
      showLabelIcon: true,
      labelTooltipProps: {
        position: 'bottom-start',
        text: 'How To Port?\nA Unique Porting Code (UPC) is needed to port your mobile number. Send "PORT" followed by your number to 1900 to receive the UPC via SMS.'
      },
      validationRegex: '^[A-Z0-9]{8}$',
      maxLength: 8
    }
  },
  dropdownsDataProps: {
    simProvider: {
      label: 'Previous network provider',
      placeholder: 'Select network provider',
      filterKey: 'subHeading',
      dropdownList: [],
      clearSearchOnDropdownListChange: false
    }
  }
};
export var successAvatarConfig = {
  avatarIcon: 'TickButtonIcon',
  avatarProps: {
    style: {
      backgroundColor: GREEN_500
    }
  }
};